import { Outlet } from "react-router-dom";
import ProjectNavbar from "../Project/ProjectNavbar";
import { useSelector } from "react-redux";
import { selectCurrentRoles } from "features/auth/authSlice";
const ProjectLayout = () => {
  const RolesFromToken = useSelector(selectCurrentRoles);

  return (
    <div className="min-h-screen bg-white">
      {/* <ProjectNavbar /> */}
      <div
        style={{
          background: "#f5f7fa",
          minHeight: "100vh",
        }}
      >
        <main
          style={{
            paddingLeft: "0",
            paddingRight: "0",
          }}
          // className="main-content"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProjectLayout;
